import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { BenefitViewType } from '@shared/benefits/entities/view-type';
import { environment as ENV } from '@environment';
import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-btn-go-to-pay',
  templateUrl: './btn-go-to-pay.component.html',
  styleUrls: ['./btn-go-to-pay.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BtnGoToPayComponent {

  @Input() disabled: boolean;
  @Input() isMobile: boolean;
  @Input() isLoadingBooking: boolean;
  @Input() buttonType = ButtonType.Primary;
  @Input() isFixed = true;
  @Input() label: string = 'BOOKING_MODULE.GO_TO_PAY';

  @Input() applyConversion: boolean;
  @Input() conversionRate: number;

  @Input() finalPrice: number;
  @Input() currencyCode: string;
  @Input() productReference: number;

  @Output() goToPay: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  public benefitViewType = BenefitViewType.Booking;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  get buttonWithPriceInfo(): boolean {
    return (!!this.applyConversion || this.enabledPriceInfo);
  }

  private get enabledPriceInfo(): boolean {
    return !!ENV.countryModules?.booking?.go_to_pay_button?.enabled_price_info;
  }

  public payButton(): void {
    if (!this.isLoadingBooking) {
      this.goToPay.emit(this.disabled);
    }
  }

}
